module.exports = __webpack_public_path__ + "static/work_Igrisca-33f1790a8959db7a64ff3107117a98ab.mp4";